import { gql } from "@apollo/client";

export default gql`
  mutation askAiDeleteRoutine($id: UUID!) {
    deleteRoutine(id: $id) {
      ok
    }
  }
`;
